<template>
  <div class="pickup-filters-sidebar">
    <div class="pickup-filters-sidebar__header">
      <div
        class="pickup-filters-sidebar__backward"
        @click="$emit('close')"
      >
        <f-sprite-icon :icon-link="$options.icons.IconArrow.id" />
      </div>
      Фильтры
    </div>

    <div class="pickup-filters-sidebar__filters">
      <pickup-filters-list v-model="innerValue" />
    </div>

    <div class="pickup-filters-sidebar__buttons">
      <ui-button
        secondary
        text="Сбросить"
        @click="resetFilters"
      />

      <ui-button
        text="Применить"
        @click="saveFilters"
      />
    </div>
  </div>
</template>

<script>
import { defaultFilters } from '@/components/checkout/delivery-selector/pickup-filters/constants';
import PickupFiltersList from '@/components/checkout/delivery-selector/pickup-filters/pickup-filters-list.vue';

import IconArrow from '@icons/arrow.svg';

export default {
  name: 'pickup-filters-sidebar',

  icons: {
    IconArrow,
  },

  components: {
    PickupFiltersList,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    innerValue: {},
  }),

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.innerValue = val;
      },
    },
  },

  methods: {
    saveFilters() {
      this.$emit('input', { ...this.innerValue });
      this.$emit('close');
    },

    resetFilters() {
      this.$emit('input', { ...defaultFilters });
    },
  },
};
</script>

<style lang="scss">
.pickup-filters-sidebar {
  position: relative;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  transition: .5s left ease;

  &__header {
    position: relative;
    padding: 14px 16px;
    height: 48px;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
  }

  &__backward {
    position: absolute;
    width: 20px;
    height: 20px;
    transform: rotate(-90deg);
    color: $gray_lu;
    cursor: pointer;
  }

  &__filters {
    flex: 1;
    overflow: auto;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 16px;

    button {
      width: 50%;
    }

    button:first-child {
      font-weight: 600;
      margin-right: 8px;
    }
  }
}

@include breakpoint("tablet") {
  .pickup-filters-sidebar {
    width: 320px;
  }
}
</style>
